/* eslint-disable indent */
/* eslint-disable max-len */
import classNames from 'classnames';
import { observer } from 'mobx-react';
import moment from 'moment';
import { useMemo, useState } from 'react';
import { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { COURSE_PERIOD_STATUS, DATE_TIME_YMD, SYSTEM_PATH, USER_TYPE, SHOW_ATTENDANCE_HISTORY_EI } from '../../core/configs/constants';
import { useStore } from '../../core/utils/hook';
import { canShowShareKnowledgeMenu, canShowTrainingListMenu } from '../../core/utils/gaMenuPermissions';
import { destroyNavbarSafe, onLoadNavbar } from '../../core/utils/main';
import TreeViewCustom from '../TreeView/TreeViewCustom';
import LinkButton from '../Buttons/LinkButton/LinkButton';
import { LogOut } from 'lucide-react';
import { functionScrollToTop } from '../../core/utils/scroll';
import { flowResult } from 'mobx';
import './style.scss';
import { getMasterCompanyIds } from '../../core/utils/gaFilter';

/** TreeView row ids 1..n+1 for GA filter modal (root + rows). */
function defaultGaFilterTreeExpandIds(length) {
    if (!length || length <= 0) {
        return [];
    }
    return Array.from({ length: length + 1 }, (_, index) => index + 1);
}

const Header = observer((props) => {

    // other
    const navigate = useNavigate();
    const location = useLocation();

    // store
    const {
        authStore: { token, userInfo, setShowLoadingSrc, logOut },
        userStore: { getUserInfoHeader, userInfoHeader, coursePeriodStatus, onAddTicketPlan, onExtendCoursePeriod, onCheckAcceptRedirectEB },
        messageStore: { getAllMessages, messages, totalMessages },
        groupAdminStore: {
            getAllChildrenGroupById, childrenOfGroup, clean, setAttrObservable, expandTreeChildrenGroupIds, selectedTreeChildrenGroupIds, selectedGroupIds,
            getCompanyDepartments, childrenDepartments, gaFilterMode, expandTreeDepartmentIds, selectedTreeDepartmentIds, selectedDepartmentIds
        },
        settingTopPageStore: { isPreview }
    } = useStore();

    const isCoursePeriodExpired = useMemo(() => {
        return coursePeriodStatus === COURSE_PERIOD_STATUS.EXPIRED
    }, [coursePeriodStatus])

    // state
    const [showMessage, setShowMessage] = useState(false);
    const [typeMessage, setTypeMessage] = useState(0);
    const [loadNavbarFirst, setLoadNavbarFirst] = useState(false);
    const [showTicketDetail, setShowTicketDetail] = useState(false);

    const [expandedIds, setExpandedIds] = useState([]);
    const [highlightExpand, setHighlightExpand] = useState([]);
    const [groupSelectedIds, setGroupSelectedIds] = useState([]);
    const [isOpenFilterModal, setIsOpenFilterModal] = useState(false);
    const [groupTreeFilterIds, setGroupTreeFilterIds] = useState([]);
    const [groupFilterIds, setGroupFilterIds] = useState([]);

    const [filterTypeModal, setFilterTypeModal] = useState('group');
    const [expandedIdsDept, setExpandedIdsDept] = useState([]);
    const [highlightExpandDept, setHighlightExpandDept] = useState([]);
    const [groupSelectedDeptIds, setGroupSelectedDeptIds] = useState([]);
    const [deptTreeFilterIds, setDeptTreeFilterIds] = useState([]);
    const [deptFilterIds, setDeptFilterIds] = useState([]);

    const isHomePage = location.pathname === '/';
    const [navKey, setNavKey] = useState(false);

    const textAddTicket = useMemo(() => {
        if (userInfoHeader) {
            const { allowBuyTicket, displayAttendanceCode } = userInfoHeader;
            if (allowBuyTicket && displayAttendanceCode) return '今すぐ受講';
            if (displayAttendanceCode) return '受講コード入力';
            return '今すぐ受講';
        }
        return '';
    }, [userInfoHeader]);

    const groupChildrenSelectedMapper = useMemo(() => {
        return childrenOfGroup.filter(item => selectedGroupIds.includes(item.id));
    }, [selectedGroupIds, childrenOfGroup]);

    const departmentChildrenSelectedMapper = useMemo(() => {
        return childrenDepartments.filter(item => selectedDepartmentIds.includes(item.id));
    }, [selectedDepartmentIds, childrenDepartments]);

    const showGaHeaderFilter =
        userInfoHeader?.showGaHeaderFilter === undefined
            ? childrenOfGroup?.length > 1
            : !!userInfoHeader?.showGaHeaderFilter;

    const showFilterTypeRadio = useMemo(() => {
        return (
            userInfo?.roleId === USER_TYPE.GROUP_MANAGER &&
            !userInfoHeader?.departmentId &&
            !!userInfoHeader?.enableDepartmentHierarchy
        );
    }, [userInfo?.roleId, userInfoHeader?.departmentId, userInfoHeader?.enableDepartmentHierarchy]);

    const gaFilterHeaderPrimary = useMemo(() => {
        if (userInfo?.roleId !== USER_TYPE.GROUP_MANAGER || !showGaHeaderFilter) {
            return '全ての法人';
        }
        if (gaFilterMode === 'department') {
            if (childrenDepartments?.length > selectedDepartmentIds?.length && departmentChildrenSelectedMapper?.length > 0) {
                return departmentChildrenSelectedMapper[0].name;
            }
            return '全ての部署';
        }
        if (childrenOfGroup?.length > groupSelectedIds?.length && groupChildrenSelectedMapper?.length > 0) {
            return groupChildrenSelectedMapper[0].name;
        }
        return '全ての法人';
    }, [userInfo?.roleId, showGaHeaderFilter, gaFilterMode, childrenDepartments, selectedDepartmentIds, departmentChildrenSelectedMapper, childrenOfGroup, groupSelectedIds, groupChildrenSelectedMapper]);

    const gaFilterHeaderExtraCount = useMemo(() => {
        if (userInfo?.roleId !== USER_TYPE.GROUP_MANAGER || !showGaHeaderFilter) {
            return null;
        }
        if (gaFilterMode === 'department') {
            if (childrenDepartments?.length > selectedDepartmentIds?.length && selectedDepartmentIds?.length > 1) {
                return selectedDepartmentIds.length - 1;
            }
            return null;
        }
        if (childrenOfGroup?.length > groupSelectedIds?.length && groupSelectedIds?.length > 1) {
            return groupSelectedIds.length - 1;
        }
        return null;
    }, [userInfo?.roleId, showGaHeaderFilter, gaFilterMode, childrenDepartments, selectedDepartmentIds, childrenOfGroup, groupSelectedIds]);

    // lifecycle
    useEffect(() => {
        const getData = async () => {
            setShowLoadingSrc(true);
            if (token) {
                await getUserInfoHeader();
                await getAllMessages({}, false, true);
            }
            // if(!loadNavbarFirst) {
            //     window.$('#main-nav').hide();
            //     setLoadNavbarFirst(true);
            // }
            setShowLoadingSrc(false);
        }
        getData();
    }, [token, location.pathname])

    useEffect(() => {
        if (!token || (token && userInfo && userInfoHeader && Object.keys(userInfoHeader).length)) {

            if (window.$('.hc-offcanvas-nav')) {
                destroyNavbarSafe();
            }
            // Re-init
            onLoadNavbar();
        }
    }, [userInfo, userInfoHeader, navKey, token, childrenOfGroup])

    useEffect(() => {
        if (userInfo?.roleId != null && userInfoHeader?.role != null && userInfo?.roleId !== userInfoHeader?.role) {
            onLogout();
        }
        clean();
        if (userInfoHeader?.id && userInfo?.roleId === USER_TYPE.GROUP_MANAGER) {
            getAllChildrenGroupById(userInfoHeader?.groupId, () => setNavKey(!navKey));
        }
    }, [userInfo, userInfoHeader])

    useEffect(() => {
        if (
            userInfoHeader?.id &&
            userInfo?.roleId === USER_TYPE.GROUP_MANAGER &&
            userInfoHeader?.showGaHeaderFilter &&
            (userInfoHeader?.hasAtLeastOneDepartment || userInfoHeader?.departmentId)
        ) {
            flowResult(getCompanyDepartments());
        }
    }, [userInfo?.roleId, userInfoHeader?.id, userInfoHeader?.showGaHeaderFilter, userInfoHeader?.hasAtLeastOneDepartment, userInfoHeader?.departmentId]);

    useEffect(() => {
        if (showMessage) {
            onClickOutSideMessage();
        }
    }, [showMessage])

    useEffect(() => {
        if (childrenOfGroup?.length > 0) {
            const fallbackExpand = defaultGaFilterTreeExpandIds(childrenOfGroup.length);
            setExpandedIds(expandTreeChildrenGroupIds?.length > 0 ? expandTreeChildrenGroupIds : fallbackExpand);
            setHighlightExpand(selectedTreeChildrenGroupIds?.length > 0 ? selectedTreeChildrenGroupIds : fallbackExpand);
            setGroupTreeFilterIds(selectedTreeChildrenGroupIds?.length > 0 ? selectedTreeChildrenGroupIds : fallbackExpand);
            const allIds = childrenOfGroup.map(item => item.id);
            const ids = selectedGroupIds?.length > 0 ? selectedGroupIds : allIds;
            setGroupSelectedIds(ids);
            setGroupFilterIds(ids);
            setAttrObservable('selectedGroupIds', ids);
        }
    }, [childrenOfGroup, expandTreeChildrenGroupIds, selectedTreeChildrenGroupIds, selectedGroupIds])

    useEffect(() => {
        if (childrenDepartments?.length > 0) {
            const fallbackExpand = defaultGaFilterTreeExpandIds(childrenDepartments.length);
            setExpandedIdsDept(expandTreeDepartmentIds?.length > 0 ? expandTreeDepartmentIds : fallbackExpand);
            setHighlightExpandDept(selectedTreeDepartmentIds?.length > 0 ? selectedTreeDepartmentIds : fallbackExpand);
            setDeptTreeFilterIds(selectedTreeDepartmentIds?.length > 0 ? selectedTreeDepartmentIds : fallbackExpand);
            const allIds = childrenDepartments.map(item => item.id);
            const ids = selectedDepartmentIds?.length > 0 ? selectedDepartmentIds : allIds;
            setGroupSelectedDeptIds(ids);
            setDeptFilterIds(ids);
            setAttrObservable('selectedDepartmentIds', ids);
        }
    }, [childrenDepartments, expandTreeDepartmentIds, selectedTreeDepartmentIds, selectedDepartmentIds])

    // function
    const onLogout = async () => {
        await flowResult(logOut());
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = SYSTEM_PATH.HOME;
    }

    const onClickOutSideMessage = () => {
        const $el = window.$('.bell');
        const $ee = window.$('.scope');

        window.$(document).unbind('click');

        window.$(document).on('click', function (e) {
            if ((window.$(e.target) != $el) && !window.$(e.target).hasClass('change-type-message') && ($ee.hasClass('active'))) {
                setShowMessage(false);
            }
        });
    }

    const onToggleShowMessage = async () => {
        if (!showMessage) {
            await getAllMessages({}, false, true);
            setTypeMessage(0);
        }
        setShowMessage(!showMessage);
    }

    const onChangeTypeMessage = async (type) => {
        await getAllMessages(type === 0 ? {} : { seen: 0 }, false, true);
        setTypeMessage(type);
    }

    const onOpenMessageDetail = (id) => {
        navigate(`${SYSTEM_PATH.MESSAGE}${id}`);
    }

    const onNavigateHome = () => {
        navigate(SYSTEM_PATH.HOME);
    }

    const onHandLeExpand = (e) => {
        if (!expandedIds.includes(e.id)) {
            setExpandedIds([...expandedIds, e.id].sort((a, b) => a - b));
        } else {
            setExpandedIds([...expandedIds].filter(item => item !== e.id))
        }
    }

    const onHandLeExpandDept = (e) => {
        if (!expandedIdsDept.includes(e.id)) {
            setExpandedIdsDept([...expandedIdsDept, e.id].sort((a, b) => a - b));
        } else {
            setExpandedIdsDept([...expandedIdsDept].filter(item => item !== e.id));
        }
    }

    const onToggleShowTicket = () => {
        const nextState = !showTicketDetail;
        setShowTicketDetail(nextState);

        if (nextState) {
            setTimeout(() => {
                handleClickOutsideTicket();
            }, 0);
        }
    };

    const onCheckedBox = (event, element) => {
        const fullExpand = defaultGaFilterTreeExpandIds(childrenOfGroup.length);
        if (element.name === '全ての法人') {
            if (event.target.checked) {
                setHighlightExpand(fullExpand);
                setGroupSelectedIds(childrenOfGroup.map(item => item.id));
            } else {
                setHighlightExpand([]);
                setGroupSelectedIds([]);
            }
        } else {
            if (event.target.checked) {
                setHighlightExpand((prev) => {
                    const temp = [...prev, element.id];
                    if (temp.length === childrenOfGroup.length) {
                        setGroupSelectedIds(childrenOfGroup.map(item => item.id));
                        return fullExpand;
                    } else {
                        setGroupSelectedIds((prev) => [...prev, element.metadata.id])
                        return temp;
                    }
                });
            } else {
                setHighlightExpand(prev => {
                    const temp = prev.filter(item => item !== element.id);
                    if (temp.length === childrenOfGroup.length) {
                        setGroupSelectedIds((prev) => prev.filter(item => item !== element.metadata.id))
                        return temp.filter(item => item !== 1)
                    } else {
                        setGroupSelectedIds((prev) => prev.filter(item => item !== element.metadata.id));
                        return temp;
                    }
                });
            }
        }
    }

    const onCheckedBoxDept = (event, element) => {
        const fullExpand = defaultGaFilterTreeExpandIds(childrenDepartments.length);
        if (element.name === '全ての部署') {
            if (event.target.checked) {
                setHighlightExpandDept(fullExpand);
                setGroupSelectedDeptIds(childrenDepartments.map(item => item.id));
            } else {
                setHighlightExpandDept([]);
                setGroupSelectedDeptIds([]);
            }
        } else {
            if (event.target.checked) {
                setHighlightExpandDept((prev) => {
                    const temp = [...prev, element.id];
                    if (temp.length === childrenDepartments.length) {
                        setGroupSelectedDeptIds(childrenDepartments.map(item => item.id));
                        return fullExpand;
                    } else {
                        setGroupSelectedDeptIds((prev) => [...prev, element.metadata.id]);
                        return temp;
                    }
                });
            } else {
                setHighlightExpandDept(prev => {
                    const temp = prev.filter(item => item !== element.id);
                    if (temp.length === childrenDepartments.length) {
                        setGroupSelectedDeptIds((prev) => prev.filter(item => item !== element.metadata.id));
                        return temp.filter(item => item !== 1);
                    } else {
                        setGroupSelectedDeptIds((prev) => prev.filter(item => item !== element.metadata.id));
                        return temp;
                    }
                });
            }
        }
    };

    function buildTree(data) {
        const map = {};
        const temp = data.map((item) => {
            const node = { ...item };
            if (node.level === 1) {
                node.parent_id = null;
            }
            return node;
        });
        temp.forEach(item => {
            map[item.id] = {
                name: item.name,
                children: [],
                metadata: { id: item.id, parent: item.parent_id }
            };
        });

        temp.forEach(item => {
            if (item.parent_id !== null && map[item.id]) {
                if (map[item.parent_id]) {
                    map[item.parent_id].children.push(map[item.id]);
                }
            }
        });

        return Object.values(map).filter(node => node.metadata.parent === null);
    }

    const getGaModalTreeViewData = (flatList, rootLabel) => ({
        name: 'すべてのテーマ',
        children: [
            {
                children: [...buildTree(flatList)],
                name: rootLabel,
                metadata: {}
            }
        ]
    });

    const resolveGaFilterModalTab = () => {
        if (userInfoHeader?.departmentId) {
            return 'department';
        }
        if (!userInfoHeader?.enableDepartmentHierarchy) {
            return 'group';
        }
        return gaFilterMode === 'department' ? 'department' : 'group';
    };

    const handleShowFilterChildrenGroupModal = async () => {
        setFilterTypeModal(resolveGaFilterModalTab());
        const mayNeedDepartments =
            userInfoHeader?.hasAtLeastOneDepartment || userInfoHeader?.departmentId;
        if (mayNeedDepartments && !childrenDepartments?.length) {
            await flowResult(getCompanyDepartments());
        }
        setIsOpenFilterModal(true);
    }

    const resetFilterModal = () => {
        const defaultGaMode = userInfoHeader?.departmentId ? 'department' : 'group';
        const allGroupIds = childrenOfGroup?.length ? childrenOfGroup.map((item) => item.id) : [];
        const allDeptIds = childrenDepartments?.length ? childrenDepartments.map((item) => item.id) : [];
        const expandGroupIds = defaultGaFilterTreeExpandIds(childrenOfGroup?.length || 0);
        const expandDeptIds = defaultGaFilterTreeExpandIds(childrenDepartments?.length || 0);

        if (childrenOfGroup?.length > 0) {
            setExpandedIds(expandGroupIds);
            setHighlightExpand(expandGroupIds);
            setGroupSelectedIds(allGroupIds);
            setGroupTreeFilterIds(expandGroupIds);
            setGroupFilterIds(allGroupIds);
            setAttrObservable('expandTreeChildrenGroupIds', expandGroupIds);
            setAttrObservable('selectedTreeChildrenGroupIds', expandGroupIds);
            setAttrObservable('selectedGroupIds', allGroupIds);
        }
        if (childrenDepartments?.length > 0) {
            setExpandedIdsDept(expandDeptIds);
            setHighlightExpandDept(expandDeptIds);
            setGroupSelectedDeptIds(allDeptIds);
            setDeptTreeFilterIds(expandDeptIds);
            setDeptFilterIds(allDeptIds);
            setAttrObservable('expandTreeDepartmentIds', expandDeptIds);
            setAttrObservable('selectedTreeDepartmentIds', expandDeptIds);
            setAttrObservable('selectedDepartmentIds', allDeptIds);
        }

        setFilterTypeModal(defaultGaMode);
        setAttrObservable('gaFilterMode', defaultGaMode);
    }

    const onCloseFilterModal = () => {
        setIsOpenFilterModal(false);
        if (!(groupTreeFilterIds.every(item => highlightExpand.includes(item)) && groupTreeFilterIds.length === highlightExpand.length)) {
            setHighlightExpand(groupTreeFilterIds);
            setGroupSelectedIds(groupFilterIds);
        }
        if (!(deptTreeFilterIds.every(item => highlightExpandDept.includes(item)) && deptTreeFilterIds.length === highlightExpandDept.length)) {
            setHighlightExpandDept(deptTreeFilterIds);
            setGroupSelectedDeptIds(deptFilterIds);
        }
    }

    const isGaApplyDisabled =
        filterTypeModal === 'group' ? !highlightExpand?.length : !highlightExpandDept?.length;

    const onClickLinkToEb = async () => {
        const res = await flowResult(onCheckAcceptRedirectEB());

        if (res?.redirectLink) {
            window.open(res.redirectLink, '_blank', 'noopener,noreferrer');
        }
    }

    const handleApplyGaFilter = () => {
        if (filterTypeModal === 'group') {
            setAttrObservable('expandTreeChildrenGroupIds', expandedIds);
            setAttrObservable('selectedTreeChildrenGroupIds', highlightExpand);
            setAttrObservable('selectedGroupIds', groupSelectedIds);
        } else {
            setAttrObservable('expandTreeDepartmentIds', expandedIdsDept);
            setAttrObservable('selectedTreeDepartmentIds', highlightExpandDept);
            setAttrObservable('selectedDepartmentIds', groupSelectedDeptIds);
        }
        setAttrObservable('gaFilterMode', filterTypeModal);
        setIsOpenFilterModal(false);
        setNavKey(!navKey);
    };

    useEffect(() => {
        setAttrObservable('masterSelectedGroupIds', getMasterCompanyIds(childrenOfGroup, selectedGroupIds));
    }, [selectedGroupIds, childrenOfGroup])

    const handleClickOutsideTicket = () => {
        const $wrapper = window.$('.ticket-wrapper');

        window.$(document).off('click.ticket');

        window.$(document).on('click.ticket', function (e) {
            if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
                setShowTicketDetail(false);
                window.$(document).off('click.ticket');
            }
        });
    };

    return (
        <>
            <header id='header-site' className={classNames('header-after-login header-after-login-for-std')}>

                <div className='header-general clearfix'>
                    {/* begin mobile */}
                    <div key={navKey} className='main-logo'>
                        <div className='wrapper cf'>
                            <nav id='main-nav'>
                                {(token && !isPreview) ? (
                                    <>
                                        <ul className='login-2'>
                                            <li className='logo-sidebar'>
                                                <img className='logo-navbar-img-sidebar' src={'/images/logo-icon-text-small.svg'} alt='' />
                                            </li>
                                            <li className='login-admin'>
                                                <span className='d-flex align-items-center'>
                                                    <span className='icon-1'><img src='/images/i-9.png' /></span>
                                                    <span className='nav-icon-1'> <div className='nav-bar-name'>{userInfoHeader?.firstName} {userInfoHeader?.lastName}</div></span>
                                                </span>
                                            </li>
                                        </ul>
                                        {userInfo?.roleId !== USER_TYPE.GROUP_MANAGER && (
                                            <ul className='login-box'>
                                                {
                                                    coursePeriodStatus !== COURSE_PERIOD_STATUS.NOT_HAVE &&
                                                    <li>
                                                        <span className={classNames('d-flex align-items-center flex-gap-5', isCoursePeriodExpired && 'warning-expired')}>
                                                            <i
                                                                className="fa-regular fa-calendar-days"
                                                                data-bs-toggle="tooltip"
                                                                data-bs-placement="bottom"
                                                                title={`受講期間 ${isCoursePeriodExpired ? '(期限切れ)' : ''}`}
                                                            />
                                                            <span>
                                                                {userInfoHeader?.coursePeriodStart?.replace(/-/g, '/')} - {userInfoHeader?.coursePeriodEnd?.replace(/-/g, '/')}
                                                            </span>
                                                        </span>
                                                    </li>
                                                }
                                                {
                                                    (!isCoursePeriodExpired && userInfoHeader?.ticket) &&
                                                    <>
                                                        <li>
                                                            <span className='d-flex align-items-center flex-gap-5'>
                                                                <i
                                                                    className="fa-solid fa-ticket"
                                                                    style={{
                                                                        rotate: '-45deg'
                                                                    }}
                                                                />
                                                                <span>{userInfoHeader?.ticket?.name}受講中</span>
                                                            </span>
                                                        </li>
                                                        {
                                                            (userInfoHeader?.isCourseTicket || userInfoHeader?.isFreeTicket) && (
                                                                <>
                                                                    <li>未受講数:</li>
                                                                    {
                                                                        userInfoHeader?.isCourseTicket &&
                                                                        <li className='red'>研修指定講座: {userInfoHeader?.remainingCourseAmountTicket ?? 0}講座</li>
                                                                    }
                                                                    {
                                                                        userInfoHeader?.isFreeTicket &&
                                                                        <li className='red'>自由選択講座: {userInfoHeader?.remainingFreeAmountTicket ?? 0}講座</li>
                                                                    }
                                                                </>
                                                            )
                                                        }
                                                    </>
                                                }
                                                {
                                                    (userInfoHeader?.allowBuyTicket || userInfoHeader?.displayAttendanceCode) &&
                                                    <li className='btn'>
                                                        <a onClick={onAddTicketPlan}>
                                                            <img src='/images/icon-buy-ticket-1.svg' alt='' />
                                                            <img src='/images/icon-buy-ticket-hover.svg' alt='' />
                                                            {textAddTicket}
                                                        </a>
                                                    </li>
                                                }
                                                {
                                                    userInfoHeader?.allowLinkToEB && (
                                                        <li className='btn btn-eb'>
                                                            <a onClick={onClickLinkToEb}>
                                                                電子書籍へ移動
                                                            </a>
                                                        </li>
                                                    )
                                                }

                                            </ul>
                                        )}
                                        {userInfo?.roleId === USER_TYPE.GROUP_MANAGER && showGaHeaderFilter && (
                                            <ul className='login-box'>
                                                <li>
                                                    <a onClick={handleShowFilterChildrenGroupModal}>
                                                        <span className='filter-children-group-header d-flex align-items-center flex-gap-5'>
                                                            <img className='filter-children-group-icon' src='/images/icon-filter-children-group.svg' alt='' />
                                                            <div className='filter-children-group-info d-flex align-items-center justify-content-between cursor-pointer width-full'>
                                                                <div className='text d-flex align-items-center flex-gap-5'>
                                                                    <span className='line-clamp-1 ga-filter-label-primary'>
                                                                        {gaFilterHeaderPrimary}
                                                                    </span>
                                                                    {gaFilterHeaderExtraCount != null && (
                                                                        <span className='ga-filter-label-extra'>{`その他${gaFilterHeaderExtraCount}件`}</span>
                                                                    )}
                                                                </div>
                                                                <i className='fa-solid fa-caret-down ga-filter-caret ga-filter-caret--sidebar' />
                                                            </div>
                                                        </span>
                                                    </a>
                                                </li>
                                            </ul>
                                        )}
                                    </>
                                ) : (
                                    <ul className='login-2'>
                                        <li className='logo-sidebar'>
                                            <img className='logo-navbar-img-sidebar' src={'/images/logo-icon-text-small.svg'} alt='' />
                                        </li>
                                    </ul>
                                )}

                                <ul className='second-nav'>
                                    {(token && !isPreview) ? (
                                        <>
                                            {
                                                token &&
                                                <li>
                                                    アカウント情報
                                                    <ul className='nav-sub-menu'>
                                                        <li>
                                                            <a onClick={() => navigate(SYSTEM_PATH.PROFILE)}>
                                                                <img src='/images/i-5.svg' /> ユーザー情報
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a onClick={() => navigate(SYSTEM_PATH.CHANGE_PASSWORD)}>
                                                                <img src='/images/i-6.svg' /> パスワード変更
                                                            </a>
                                                        </li>
                                                        {
                                                            (userInfo?.roleId === USER_TYPE.STUDENT_INDIVIDUAL || userInfo?.roleId === USER_TYPE.STUDENT_GROUP) &&
                                                            <>
                                                                <li>
                                                                    <Link to={SYSTEM_PATH.PURCHASE_HISTORY}>
                                                                        <img src='/images/i-7.svg' /> 購入履歴
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <Link to={SYSTEM_PATH.TOOL_CERTIFICATE}>
                                                                        <img src='/images/i-17.svg' /> 単位管理ツール
                                                                    </Link>
                                                                </li>
                                                            </>
                                                        }
                                                        {
                                                            userInfo?.roleId === USER_TYPE.GROUP_MANAGER &&
                                                            <>
                                                                {
                                                                    canShowTrainingListMenu(userInfoHeader) && (
                                                                        <li><a onClick={() => navigate(SYSTEM_PATH.COMPANY_TRAINING_LIST)}><img src='/images/icon-company-training-list.svg' />  研修一覧</a></li>
                                                                    )
                                                                }
                                                                {
                                                                    canShowShareKnowledgeMenu(userInfoHeader) && (
                                                                        <>
                                                                            <li><a onClick={() => navigate(SYSTEM_PATH.SHARE_KNOWLEDGE)}><img src='/images/icon-share-knowledge.png' />  シェアナレッジ</a></li>
                                                                            <li><a onClick={() => navigate(SYSTEM_PATH.SHARE_KNOWLEDGE_REQUEST_LIST)}><img src='/images/icon-request-lst-history.svg' />  利用履歴</a></li>
                                                                        </>
                                                                    )
                                                                }
                                                            </>
                                                        }
                                                        <li>
                                                            <a onClick={() => navigate(SYSTEM_PATH.ACCOUNT_SETTING)}>
                                                                <img src='/images/account_settings.svg' alt='' /> メールニュース受信設定
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>
                                            }
                                            {
                                                token && (userInfo?.roleId === USER_TYPE.STUDENT_INDIVIDUAL || userInfo?.roleId === USER_TYPE.STUDENT_GROUP) &&
                                                <>
                                                    {
                                                        userInfoHeader?.isTrainingPeriod ? (
                                                            <li>
                                                                受講状況
                                                                <ul className='nav-sub-menu'>
                                                                    <li>
                                                                        <Link to={SYSTEM_PATH.ATTENDANCE_HISTORY}>全講座</Link>
                                                                    </li>
                                                                    {SHOW_ATTENDANCE_HISTORY_EI && userInfoHeader?.syncEnable && (
                                                                        <li>
                                                                            <Link to={SYSTEM_PATH.ATTENDANCE_HISTORY_EI}>受講履歴EI</Link>
                                                                        </li>
                                                                    )}
                                                                    <li>
                                                                        <Link to={SYSTEM_PATH.TRAINING_LIST}>研修指定講座</Link>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        ) : (
                                                            <>
                                                                {(SHOW_ATTENDANCE_HISTORY_EI && userInfoHeader?.syncEnable) ? (
                                                                    <li>
                                                                        受講履歴
                                                                        <ul className='nav-sub-menu'>
                                                                            <li>
                                                                                <Link to={SYSTEM_PATH.ATTENDANCE_HISTORY}>受講履歴</Link>
                                                                            </li>
                                                                            {/* <li>
                                                                                <Link to={SYSTEM_PATH.ATTENDANCE_HISTORY_EI}>受講履歴EI</Link>
                                                                            </li> */}
                                                                        </ul>
                                                                    </li>
                                                                ) : (
                                                                    <li>
                                                                        <Link to={SYSTEM_PATH.ATTENDANCE_HISTORY}>受講履歴</Link>
                                                                    </li>
                                                                )}
                                                            </>

                                                        )
                                                    }
                                                    <li>
                                                        <Link to={SYSTEM_PATH.THEMES}>講座一覧</Link>
                                                    </li>
                                                </>
                                            }
                                            {
                                                userInfo?.roleId === USER_TYPE.GROUP_MANAGER &&
                                                <li>
                                                    <a onClick={() => navigate(SYSTEM_PATH.STUDENT_GROUP_LIST)}>受講者管理</a>
                                                </li>
                                            }
                                            {
                                                (!token || userInfo?.roleId === USER_TYPE.GROUP_MANAGER) &&
                                                <li>
                                                    <a onClick={() => navigate(SYSTEM_PATH.THEMES)}>講座一覧</a>
                                                </li>
                                            }
                                            {
                                                !token &&
                                                <li>
                                                    <Link to={SYSTEM_PATH.TICKETS}>受講プラン案内</Link>
                                                </li>
                                            }
                                            <li>
                                                <a onClick={() => navigate(SYSTEM_PATH.USER_GUIDE)}>利用案内</a>
                                            </li>
                                            <li>
                                                <a onClick={() => navigate(SYSTEM_PATH.FAQ_SCREEN)}>よくある質問</a>
                                            </li>
                                            <li>
                                                <a onClick={() => navigate(SYSTEM_PATH.SEND_INQUIRY)}>お問い合わせ</a>
                                            </li>
                                            <li onClick={onLogout}>
                                                <a><LogOut /> ログアウト</a>
                                            </li>
                                        </>
                                    ) : (
                                        <MenuTopPageBeforeLogin isMobile={true} />
                                    )}
                                </ul>
                                {(!token || isPreview) && (
                                    <ul className='link-login sidebar'>
                                        <li className='link-login-button'>
                                            <LinkButton                                               
                                                href={isPreview ? undefined : SYSTEM_PATH.LOGIN}
                                                variant='orange'
                                                onClick={(e) => {
                                                    if (isPreview) {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                    }
                                                }}
                                            >
                                                ログイン
                                            </LinkButton>
                                        </li>
                                        <li className='link-login-button'>
                                            <LinkButton
                                                href={isPreview ? undefined : SYSTEM_PATH.SEND_INQUIRY}
                                                variant='green'
                                                className='link-register-button'
                                                onClick={(e) => {
                                                    if (isPreview) {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                    }
                                                }}
                                            >
                                                問い合わせ
                                            </LinkButton>
                                        </li>
                                    </ul>
                                )}
                            </nav>
                            <a className='toggle'>
                                <span />
                            </a>
                        </div>

                        {/* Logo */}
                        <div className='logo-navbar'>
                            <img
                                className='logo-navbar-img logo-navbar-img-pc'
                                src={'/images/logo-icon-new.png'}
                                alt=''
                                onClick={onNavigateHome}
                            />
                            <div className='logo-navbar-text'>
                                臨床で活躍する薬剤師のための
                                <br />
                                研修認定対応eラーニングサイト
                            </div>

                            <img
                                className='logo-navbar-img logo-navbar-img-mb'
                                src={'/images/logo-mb-new.svg'}
                                alt=''
                                onClick={onNavigateHome}
                            />
                        </div>

                        {
                            (token && !isPreview) ? (
                                <div className='menu-header menu-header-mobile'>
                                    <ul>
                                        <li className='li-bell'>
                                            <a className='click-bell bell' onClick={() => onToggleShowMessage()}>
                                                <i className='fa fa-bell' aria-hidden='true' />
                                                {totalMessages?.notSeen > 0 && <span className='dot'>{totalMessages?.notSeen ? totalMessages.notSeen > 99 ? '99+' : totalMessages.notSeen : 0}</span>}
                                            </a>
                                            {
                                                showMessage &&
                                                <div className='content-bell scope active'>
                                                    <div className='content arrow-top arrow'>
                                                        <h3 className='title-2'>メッセージ</h3>
                                                        <div className='tab'>
                                                            <ul>
                                                                <li className={classNames(typeMessage === 0 && 'active')}> <a className='change-type-message' role={'button'} onClick={() => onChangeTypeMessage(0)}>全て ({totalMessages?.all ?? 0})</a></li>
                                                                <li className={classNames(typeMessage === 1 && 'active')}> <a className='change-type-message' role={'button'} onClick={() => onChangeTypeMessage(1)}>未読 ({totalMessages?.notSeen ?? 0})</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className='nav-content-bell'>
                                                        <div className='scrollbar-message' id='style-2'>
                                                            <div className='force-overflow'>
                                                                {
                                                                    messages?.length > 0 ?
                                                                        messages.map(e => (
                                                                            <a onClick={() => onOpenMessageDetail(e.id)} className={'link-message-detail'} key={e.id}>
                                                                                <div role={'button'} className={classNames('item', e.isSeen && 'item-3')}>
                                                                                    <div className='content-message'>
                                                                                        {e.senderRole === 1 && <p className='message-ga'>企業管理者より</p>}
                                                                                        <h4 className='title-3'> {e.title}</h4>
                                                                                        {
                                                                                            !e.isNotifyExpireCoursePeriod ?
                                                                                                <p className='desc'>{e.content}</p> :
                                                                                                <p className='desc desc-full' style={{ textAlign: 'left' }}>
                                                                                                    <span>受講期間終了まで残り{e.content}となりました。 下記より受講期間の更新が可能となり ますのでお早めにお手続きをお願いいたします。 </span>
                                                                                                    <br />
                                                                                                    <span className='text-decoration-underline text-hover-link' onClick={onExtendCoursePeriod}>受講プランの申込み</span>
                                                                                                </p>
                                                                                        }
                                                                                        <p className='date'>{e.createdAt && moment(e.sendDate || e.createdAt).format(DATE_TIME_YMD)}</p>
                                                                                    </div>
                                                                                    {!e.isSeen && <div className='dot' />}
                                                                                </div>
                                                                            </a>
                                                                        ))
                                                                        :
                                                                        <div className='text-center'>データはありません</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        {
                                                            messages?.length > 0 &&
                                                            <div className='readmore'>
                                                                <Link to={SYSTEM_PATH.MESSAGES}>全表示</Link>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </li>
                                    </ul>
                                </div>
                            ) : (
                                <div className='menu-header menu-header-mobile before-login'>
                                    <Link
                                        to={isPreview ? undefined : SYSTEM_PATH.LOGIN}
                                        className=''
                                        onClick={(e) => {
                                            if (isPreview) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                            }
                                        }}
                                    >
                                        ログイン
                                    </Link>
                                </div>
                            )}
                    </div >

                    <div className='menu-header'>
                        <ul>
                            {
                                (token && !isPreview) ?
                                    <>
                                        {
                                            userInfo?.roleId !== USER_TYPE.GROUP_MANAGER ?
                                                <>
                                                    {
                                                        coursePeriodStatus !== COURSE_PERIOD_STATUS.NOT_HAVE &&
                                                        <li className='li-date'>
                                                            <a className='d-flex align-items-center flex-gap-5'>
                                                                <span
                                                                    className={classNames('d-flex align-items-center flex-gap-5 cursor-pointer-none', isCoursePeriodExpired && 'warning-expired')}
                                                                    data-bs-toggle="tooltip"
                                                                    data-bs-placement="bottom"
                                                                    title={'受講期間'}
                                                                >
                                                                    <i
                                                                        className="fa-regular fa-calendar-days"
                                                                    />
                                                                    {userInfoHeader?.coursePeriodStart?.replace(/-/g, '/')} - {userInfoHeader?.coursePeriodEnd?.replace(/-/g, '/')}
                                                                </span>
                                                                <div className={classNames('text-center', isCoursePeriodExpired && 'warning-expired')}>{`${isCoursePeriodExpired ? '(期限切れ)' : ''}`}</div>
                                                            </a>
                                                        </li>
                                                    }
                                                    {
                                                        (!isCoursePeriodExpired && userInfoHeader?.ticket) &&
                                                        <>
                                                            <li className='li-date'>
                                                                <a>
                                                                    <div className={classNames('d-flex align-items-center gap-2 ticket-wrapper')}
                                                                        onClick={() => onToggleShowTicket()}
                                                                    >
                                                                        <i
                                                                            className="fa-solid fa-ticket"
                                                                            style={{
                                                                                rotate: '-45deg'
                                                                            }}
                                                                        />
                                                                        {userInfoHeader?.ticket?.ids?.length > 1 ? (
                                                                            <>
                                                                                <div className="ticket-info">
                                                                                    <span className='ticket-number'>{userInfoHeader.ticket.ids.length}受講プラン</span>受講中
                                                                                </div>

                                                                                {showTicketDetail && userInfoHeader?.ticket?.names?.length > 0 && (
                                                                                    <div className="ticket-detail">
                                                                                        {userInfoHeader.ticket.names.map(n => (
                                                                                            <div className="ticket-item" key={n}>
                                                                                                {n}受講中
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <span>{userInfoHeader?.ticket?.name}受講中</span>
                                                                        )}
                                                                    </div>
                                                                </a>
                                                            </li>
                                                            <li className='li-ticket'>
                                                                {
                                                                    (userInfoHeader?.isCourseTicket || userInfoHeader?.isFreeTicket) && (
                                                                        <a>
                                                                            未受講数:
                                                                            <span className='invisible'> </span>
                                                                            {
                                                                                userInfoHeader?.isCourseTicket &&
                                                                                <span>{userInfoHeader?.remainingCourseAmountTicket ?? 0}講座 (研修指定講座)</span>
                                                                            }
                                                                            {
                                                                                userInfoHeader?.isCourseTicket && userInfoHeader?.isFreeTicket &&
                                                                                <span> | </span>
                                                                            }
                                                                            {
                                                                                userInfoHeader?.isFreeTicket &&
                                                                                <span>{userInfoHeader?.remainingFreeAmountTicket ?? 0}講座 (自由選択講座)</span>
                                                                            }
                                                                        </a>
                                                                    )
                                                                }
                                                                
                                                            </li>
                                                        </>
                                                    }
                                                </> : (
                                                    showGaHeaderFilter && (
                                                        <span className='filter-children-group-header d-flex align-items-center flex-gap-5'>
                                                            <img className='filter-children-group-icon' src='/images/icon-filter-children-group.svg' alt='' />
                                                            <div
                                                                className='filter-children-group-info d-flex align-items-center justify-content-between cursor-pointer width-full'
                                                                onClick={handleShowFilterChildrenGroupModal}
                                                            >
                                                                <div className='text d-flex align-items-center flex-gap-5'>
                                                                    <span className='line-clamp-1 ga-filter-label-primary'>
                                                                        {gaFilterHeaderPrimary}
                                                                    </span>
                                                                    {gaFilterHeaderExtraCount != null && (
                                                                        <span className='ga-filter-label-extra'>{`その他${gaFilterHeaderExtraCount}件`}</span>
                                                                    )}
                                                                </div>
                                                                <i className='fa-solid fa-caret-down ga-filter-caret ga-filter-caret--mainnav' />
                                                            </div>
                                                        </span>
                                                    )
                                                )
                                        }
                                        <li className='li-bell'>
                                            <a className='click-bell bell' onClick={() => onToggleShowMessage()}>
                                                <img src='/images/icon7.svg' alt='' />
                                                {totalMessages?.notSeen > 0 && <span className='dot'>{totalMessages?.notSeen ? totalMessages.notSeen > 99 ? '99+' : totalMessages.notSeen : 0}</span>}
                                            </a>
                                            {
                                                showMessage &&
                                                <div className='content-bell scope active'>
                                                    <div className='content arrow-top arrow'>
                                                        <h3 className='title-2'>メッセージ</h3>
                                                        <div className='tab'>
                                                            <ul>
                                                                <li className={classNames(typeMessage === 0 && 'active')}>  <a className='change-type-message' role={'button'} onClick={() => onChangeTypeMessage(0)}>全て ({totalMessages?.all ?? 0})</a></li>
                                                                <li className={classNames(typeMessage === 1 && 'active')}>  <a className='change-type-message' role={'button'} onClick={() => onChangeTypeMessage(1)}>未読 ({totalMessages?.notSeen ?? 0})</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className='nav-content-bell'>
                                                        <div className='scrollbar-message' id='style-2'>
                                                            <div className='force-overflow'>
                                                                {
                                                                    messages?.length > 0 ?
                                                                        messages.map(e => (
                                                                            <a key={e.id} onClick={() => onOpenMessageDetail(e.id)} className='link-message-detail'>
                                                                                <div role={'button'} className={classNames('item', e.isSeen && 'item-3')}>
                                                                                    <div className='content-message'>
                                                                                        {e.senderRole === 1 && <p className='message-ga'>企業管理者より</p>}
                                                                                        <h4 className='title-3'>{e.title}</h4>
                                                                                        {
                                                                                            !e.isNotifyExpireCoursePeriod ?
                                                                                                <p className='desc'>{e.content}</p> :
                                                                                                <p className='desc desc-full'>
                                                                                                    <span>受講期間終了まで残り{e.content}となりました。 下記より受講期間の更新が可能となり ますのでお早めにお手続きをお願いいたします。 </span>
                                                                                                    <br />
                                                                                                    <span className='text-decoration-underline text-hover-link' onClick={onExtendCoursePeriod}>受講プランの申込み</span>
                                                                                                </p>
                                                                                        }
                                                                                        <p className='date'>{e.createdAt && moment(e.sendDate || e.createdAt).format(DATE_TIME_YMD)}</p>
                                                                                    </div>
                                                                                    {!e.isSeen && <div className='dot' />}
                                                                                </div>
                                                                            </a>
                                                                        ))
                                                                        :
                                                                        <div className='text-center'>データはありません</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        {
                                                            messages?.length > 0 &&
                                                            <div className='readmore'>
                                                                <Link to={SYSTEM_PATH.MESSAGES}>全表示</Link>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </li>
                                        <li className='li-last'>
                                            <a className='li-infor-user'>
                                                <span className='icon user-icon'>
                                                    <img src={'/images/icon9.svg'} alt='' />
                                                    {
                                                        token && (userInfoHeader?.roleId === USER_TYPE.STUDENT_GROUP || userInfoHeader?.roleId === USER_TYPE.STUDENT_INDIVIDUAL) && !userInfoHeader?.isSettingToolcertificate && (
                                                            <img className='user-warning-icon' src="/images/warning_icon.svg" alt="" />
                                                        )
                                                    }
                                                </span>
                                                <span className='nav-icon'>
                                                    <b>{userInfoHeader?.firstName} {userInfoHeader?.lastName}様</b>
                                                    <br />
                                                    アカウント情報
                                                    <i className='fa fa-caret-down' aria-hidden='true' />
                                                </span>
                                            </a>
                                            <ul className='sub-login'>
                                                <li role={'button'}>
                                                    <Link to={SYSTEM_PATH.PROFILE}>
                                                        <img src={'/images/i-1.svg'} alt='' />
                                                        <img src={'/images/i-1-hover.png'} alt='' />
                                                        ユーザー情報
                                                    </Link>
                                                </li>
                                                <li role={'button'}>
                                                    <Link to={SYSTEM_PATH.CHANGE_PASSWORD}>
                                                        <img src={'/images/i-2.svg'} alt='' />
                                                        <img src={'/images/i-2-hover.png'} alt='' />
                                                        パスワード変更
                                                    </Link>
                                                </li>
                                                {
                                                    (userInfo?.roleId === USER_TYPE.STUDENT_INDIVIDUAL || userInfo?.roleId === USER_TYPE.STUDENT_GROUP) &&
                                                    <>
                                                        <li role={'button'}>
                                                            <Link to={SYSTEM_PATH.PURCHASE_HISTORY}>
                                                                <img src={'/images/i-3.svg'} alt='' />
                                                                <img src={'/images/i-3-hover.png'} alt='' />
                                                                購入履歴
                                                            </Link>
                                                        </li>
                                                        <li role={'button'}>
                                                            <Link to={SYSTEM_PATH.TOOL_CERTIFICATE}>
                                                                <img src={'/images/i-17.svg'} alt='' />
                                                                <img src={'/images/i-17-hover.png'} alt='' />
                                                                単位管理ツール
                                                            </Link>
                                                        </li>
                                                    </>
                                                }
                                                {
                                                    userInfo?.roleId === USER_TYPE.GROUP_MANAGER &&
                                                    <>
                                                        {
                                                            canShowTrainingListMenu(userInfoHeader) && (
                                                                <li role={'button'}>
                                                                    <Link to={SYSTEM_PATH.COMPANY_TRAINING_LIST}>
                                                                        <img src={'/images/icon-company-training-list.svg'} alt='' />
                                                                        <img src={'/images/icon-company-training-list-hover.png'} alt='' />
                                                                        研修一覧
                                                                    </Link>
                                                                </li>
                                                            )
                                                        }
                                                        {
                                                            canShowShareKnowledgeMenu(userInfoHeader) && (
                                                                <>
                                                                    <li role={'button'}>
                                                                        <Link to={SYSTEM_PATH.SHARE_KNOWLEDGE}>
                                                                            <img src={'/images/icon-share-knowledge.png'} alt='' />
                                                                            <img src={'/images/icon-share-knowledge-hover.png'} alt='' />
                                                                            シェアナレッジ
                                                                        </Link>
                                                                    </li>
                                                                    <li role={'button'}>
                                                                        <Link to={SYSTEM_PATH.SHARE_KNOWLEDGE_REQUEST_LIST}>
                                                                            <img src={'/images/icon-request-lst-history.svg'} alt='' />
                                                                            <img src={'/images/icon-request-lst-history-hover.png'} alt='' />
                                                                            利用履歴
                                                                        </Link>
                                                                    </li>
                                                                </>
                                                            )
                                                        }
                                                    </>
                                                }

                                                <li role={'button'}>
                                                    <Link
                                                        className='sub-login-link-account-settings'
                                                        to={SYSTEM_PATH.ACCOUNT_SETTING}
                                                    >
                                                        <img src={'/images/account_settings.svg'} alt='' />
                                                        <img src={'/images/account_settings.svg'} alt='' />
                                                        メールニュース受信設定
                                                    </Link>
                                                </li>

                                                <li role={'button'} onClick={onLogout}>
                                                    <a >
                                                        <img src={'/images/i-4.svg'} alt='' />
                                                        <img src={'/images/i-4-hover.png'} alt='' />
                                                        ログアウト
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                    </>
                                    :
                                    <>
                                        <li id='link-login-button' style={{display: isHomePage && 'block' }}>
                                            <LinkButton
                                                href={isPreview ? undefined : SYSTEM_PATH.LOGIN}
                                                className='register-login'
                                                onClick={(e) => {
                                                    if (isPreview) {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                    }
                                                }}
                                            >
                                                ログイン
                                            </LinkButton>
                                        </li>
                                        <li>
                                            <LinkButton
                                                href={isPreview ? undefined : SYSTEM_PATH.SEND_INQUIRY}
                                                className='register-login register-login-2'
                                                onClick={(e) => {
                                                    if (isPreview) {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                    }
                                                }}
                                            >
                                                問い合わせ
                                            </LinkButton>
                                        </li>
                                    </>
                            }
                        </ul>
                    </div>
                </div >

                {/* header bottom */}
                <div className='menu-header-for-std header-general'>

                    {(token && !isPreview) ? (
                        <>
                            {/* Header after login */}
                            {
                                userInfo?.roleId === USER_TYPE.GROUP_MANAGER ? (
                                    <li>
                                        <Link to={SYSTEM_PATH.STUDENT_GROUP_LIST} className='item-menu-header'>
                                            受講者管理
                                        </Link>
                                    </li>
                                ) : (
                                    userInfoHeader?.isTrainingPeriod ? (
                                        <li className='item-menu-header-hover'>
                                            <div className='item-menu-header'>
                                                受講状況
                                                <div className='item-menu-show-hover'>
                                                    <Link className='link-show-hover' to={SYSTEM_PATH.ATTENDANCE_HISTORY}>全講座</Link>
                                                    {SHOW_ATTENDANCE_HISTORY_EI && <Link className='link-show-hover' to={SYSTEM_PATH.ATTENDANCE_HISTORY_EI}>受講履歴EI</Link>}
                                                    <Link className='link-show-hover' to={SYSTEM_PATH.TRAINING_LIST}>研修指定講座</Link>
                                                </div>
                                            </div>
                                        </li>
                                    ) : (
                                        <>
                                            {(SHOW_ATTENDANCE_HISTORY_EI && userInfoHeader?.syncEnable) ? (
                                                <li className='item-menu-header-hover'>
                                                    <div className='item-menu-header'>
                                                        受講履歴
                                                        <div className='item-menu-show-hover'>
                                                            <Link className='link-show-hover' to={SYSTEM_PATH.ATTENDANCE_HISTORY}>受講履歴</Link>
                                                            {/* <Link className='link-show-hover' to={SYSTEM_PATH.ATTENDANCE_HISTORY_EI}>受講履歴EI</Link> */}
                                                        </div>
                                                    </div>
                                                </li>
                                            ) : (

                                                <li>
                                                    <Link to={SYSTEM_PATH.ATTENDANCE_HISTORY} className='item-menu-header'>受講履歴</Link>
                                                </li>
                                            )}
                                        </>
                                    )
                                )
                            }

                            <li>
                                <Link to={SYSTEM_PATH.THEMES} className='item-menu-header'>講座一覧</Link>
                            </li>
                            {/* {!token && (
                                <li>
                                    <Link to={SYSTEM_PATH.TICKETS} className='item-menu-header'>受講プラン案内</Link>
                                </li>
                            )} */}
                            <li>
                                <Link to={SYSTEM_PATH.USER_GUIDE} className='item-menu-header'>利用案内</Link>
                            </li>
                            <li>
                                <Link to={SYSTEM_PATH.FAQ_SCREEN} className='item-menu-header'>よくある質問</Link>
                            </li>
                            <li>
                                <Link to={SYSTEM_PATH.SEND_INQUIRY} className='item-menu-header'>お問い合わせ</Link>
                            </li>
                            {
                                userInfo?.roleId !== USER_TYPE.GROUP_MANAGER && (userInfoHeader?.allowBuyTicket || userInfoHeader?.displayAttendanceCode) &&
                                <li className='btn-t'>
                                    <a role={'button'} onClick={onAddTicketPlan} className='d-flex align-items-center flex-gap-10'>
                                        <img src='/images/icon-buy-ticket-1.svg' alt='' />
                                        <img src='/images/icon-buy-ticket-hover.svg' alt='' />
                                        {textAddTicket}
                                    </a>
                                </li>
                            }
                            {
                                userInfoHeader?.allowLinkToEB && (
                                    <li className='btn-eb'>
                                        <a role={'button'} onClick={onClickLinkToEb} className='d-flex align-items-center flex-gap-10'>
                                            電子書籍へ移動
                                        </a>
                                    </li>
                                )
                            }

                        </>
                    ) : (
                        <MenuTopPageBeforeLogin isMobile={false} />
                    )}
                </div>

                {/* header warning preview */}
                {isPreview && (
                    <div className='header-bottom-text-warning' >
                        <i className="fa-solid fa-triangle-exclamation" style={{ color: '#FCC21B', fontSize: 18, marginRight: 8 }}></i>
                        <div>
                            <span style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>注意：</span>
                            こちらは下書き設定のプレビューモードです。このモードでトップページに表示される内容は、まだ正式に公開されておらず、あなただけが確認できます。
                        </div>
                    </div >
                )}
            </header >
            {
                isOpenFilterModal && (
                    <div className='filter-modal-overlay'>
                        <div className='filter-modal-content ga-filter-modal-content-fixed'>
                            <div className='modal-header pd-lr-15 pd-tb-10'>
                                <h4 className='modal-title'>{filterTypeModal === 'department' ? '部署で絞り込む' : '法人で絞り込む'}</h4>
                                <button
                                    type='button'
                                    className='btn-close'
                                    onClick={() => onCloseFilterModal()}
                                >
                                </button>
                            </div>
                            {showFilterTypeRadio && (
                                <div className='ga-header-filter-type pd-lr-15 pd-t-15 pd-b-10'>
                                    <p className='ga-header-filter-type-title'>フィルタータイプを選択</p>
                                    <div className='ga-header-filter-type-row'>
                                        <label className='ga-header-filter-type-option'>
                                            <input
                                                type='radio'
                                                name='gaFilterType'
                                                className='custom-radio'
                                                checked={filterTypeModal === 'group'}
                                                onChange={() => setFilterTypeModal('group')}
                                            />
                                            <span>法人で絞り込む</span>
                                        </label>
                                        <label className='ga-header-filter-type-option'>
                                            <input
                                                type='radio'
                                                name='gaFilterType'
                                                className='custom-radio'
                                                checked={filterTypeModal === 'department'}
                                                onChange={() => setFilterTypeModal('department')}
                                            />
                                            <span>部署で絞り込む</span>
                                        </label>
                                    </div>
                                </div>
                            )}
                            <div className='ga-filter-modal-tree-wrap align-items-start pd-lr-15'>
                                {filterTypeModal === 'group' && (
                                    <>
                                        {childrenOfGroup?.length > 0 ? (
                                            <TreeViewCustom
                                                data={getGaModalTreeViewData(childrenOfGroup, '全ての法人')}
                                                className='align-items-start'
                                                onHandLeExpand={onHandLeExpand}
                                                expandedIds={expandedIds}
                                                onCheckedBox={onCheckedBox}
                                                checkedIds={highlightExpand}
                                                isCheckboxSelected
                                            />
                                        ) : (
                                            <div className='ga-filter-modal-empty'>データはありません</div>
                                        )}
                                    </>
                                )}
                                {filterTypeModal === 'department' && (
                                    <>
                                        {childrenDepartments?.length > 0 ? (
                                            <TreeViewCustom
                                                data={getGaModalTreeViewData(childrenDepartments, '全ての部署')}
                                                className='align-items-start'
                                                onHandLeExpand={onHandLeExpandDept}
                                                expandedIds={expandedIdsDept}
                                                onCheckedBox={onCheckedBoxDept}
                                                checkedIds={highlightExpandDept}
                                                isCheckboxSelected
                                            />
                                        ) : (
                                            <div className='ga-filter-modal-empty'>データはありません</div>
                                        )}
                                    </>
                                )}
                            </div>
                            <div
                                className={classNames(
                                    'add-attendance-code',
                                    'parent-company-filter-modal',
                                    'ga-filter-modal-actions',
                                    'd-flex pd-20 align-items-center justify-content-center flex-gap-50'
                                )}
                            >
                                <button
                                    type='button'
                                    className='cancel'
                                    onClick={resetFilterModal}
                                >
                                    リセット
                                </button>
                                <button
                                    disabled={isGaApplyDisabled}
                                    type='button'
                                    className={classNames(
                                        'submit',
                                        'ga-filter-modal-submit',
                                        isGaApplyDisabled && 'opacity-50'
                                    )}
                                    onClick={handleApplyGaFilter}
                                >
                                    適用
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    );
});

export default Header;

const MenuTopPageBeforeLogin = observer(({ isMobile }) => {
    // hook
    const navigate = useNavigate();

    // store
    const {
        settingTopPageStore: { isPreview }
    } = useStore();

    const menuItems = [
        {
            // id: '#id-section-services',
            id: '#id-about-elephamt',
            label: 'エレファントとは',
            offset: 0,
            offsetMobile: 0
        },
        {
            id: '#id-section-introduction',
            label: 'コンテンツ紹介',
            offset: 100,
            offsetMobile: 0
        },
        {
            id: '#id-section-price',
            label: '料金プラン',
            offset: -100,
            offsetMobile: -40
        },
        {
            id: '#id-section-pec',
            label: 'PECS申請までの５Steps',
            offset: -100,
            offsetMobile: -10
        },
        {
            id: '#id-section-faq',
            label: 'よくあるご質問',
            offset: 0,
            offsetMobile: 20
        }
    ];

    return (
        <>
            <li onClick={() => functionScrollToTop(0)}>
                <Link
                    to={isPreview ? undefined : SYSTEM_PATH.HOME}
                    className='item-menu-header'
                    onClick={(e) => {
                        if (isPreview) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }}
                >
                    ホーム
                </Link>
            </li>
            {menuItems?.map(item => {
                const offSet = isMobile ? item?.offsetMobile : item?.offset;
                return (
                    <li key={item?.id}>
                        <a
                            href={isPreview ? undefined : `/${item?.id}`}
                            className='item-menu-header'
                            onClick={(e) => {
                                e.preventDefault();
                                if (isPreview) {
                                    e.stopPropagation();
                                    return;
                                }
                                navigate(isPreview ? SYSTEM_PATH.HOME_PREVIEW : SYSTEM_PATH.HOME, { state: { scrollTo: item.id, offset: offSet } });
                            }}
                        >{item?.label}</a>
                    </li>
                )
            })}
        </>
    )
});
